import Immobilie from "@/models/immobilie.model";
import CachedPhoto from "@/models/photo/cached-photo.model";
import { ComputedRef } from "vue";
import { uploadPhoto } from "@/api/UploadApi";

export default function useImmobilieHelper(immobilie: Immobilie) {
  function getVerwalterLabel() {
    if (!immobilie?.verwalters || immobilie?.verwalters?.length === 0) return;
    return immobilie.verwalters[0].organisation;
  }

  async function uploadVorschaubild(
    photo: CachedPhoto,
    propertyId: { value: Number }
  ) {
    console.log("uploadVorschaubild start...");
    const result = await uploadPhoto(
      photo,
      "api::immobilie.immobilie",
      propertyId.value?.toString(),
      "vorschaubild",
      propertyId.value + Date.now().toString() + ".jpeg",
      "immobilie"
    );

    // fotoID auslesen
    const res = await Immobilie.api().post("/immobilie/addImmoPhoto", {
      propertyId: propertyId.value?.toString(),
      imageId: result.data[0].id,
    });
    // console.log('useProperty: Send post request to add immo photo...', 'Response: ', res);

    // const { loadImmobilienPreviews } = useProperties();
    // await loadImmobilienPreviews();
  }

  async function uploadImmoBilder(
    photos: CachedPhoto[],
    propertyId: { value: Number }
  ) {
    console.log("uploadImmoBilder start...");

    const results = await Promise.all(
      photos.map((el) => {
        return uploadPhoto(
          el,
          "api::immobilie.immobilie",
          propertyId.value?.toString(),
          "bilder",
          propertyId.value + Date.now().toString() + ".jpeg",
          "immobilie"
        );
      })
    );
  }

  return {
    getVerwalterLabel,
    uploadVorschaubild,
    uploadImmoBilder,
  };
}
